(function($) {
    
    const floatingWhatsapp = document.querySelector('.floating-whatsapp')
    
    if(floatingWhatsapp) {
        const button = floatingWhatsapp.querySelector('.floating-whatsapp-button')
        const wpcf7 = floatingWhatsapp.querySelector('.wpcf7')
        
        const pageWhatsAppLinks = document.querySelectorAll('a[href*="wa.me"], a[href*="whatsapp"]')
        
        // Redireciona o funcionamento dos links padrão para o WhatsApp flutuante
        if(pageWhatsAppLinks && button) {
            pageWhatsAppLinks.forEach(el => {
                el.addEventListener('click', event => {
                    event.preventDefault()
                    button.click()
                })
            })
        }
        
        // Funcionamento do botão flutuante
        if(button && wpcf7) {
            const address = button.dataset.address
            const cookieName = button.dataset.cookie
            let cookie = null
            let sent = false
            let formTimeout = 0
            let focusTimeout = 0
            
            function closeForm() {
                clearTimeout(formTimeout)
                floatingWhatsapp.classList.remove('active')
            }
            
            button.addEventListener('click', () => {
                const firstInput = floatingWhatsapp.querySelector('input:not([type="hidden"]), select, textarea')
                
                clearTimeout(formTimeout)
                clearTimeout(focusTimeout)
                
                if(floatingWhatsapp.classList.contains('active') && firstInput) {
                    focusTimeout = setTimeout(() => firstInput.focus(), 250)
                }
                
                if(cookieName) {
                    cookie = document.cookie
                        .split(';')
                        .find(el => el.startsWith(cookieName))
                }
                
                if(((cookie && cookie.split('=')[1] === 'true') || sent) && address) {
                    sent = true
                    window.open(address, '_blank')
                } else {
                    floatingWhatsapp.classList.toggle('active')
                }
            })
            
            floatingWhatsapp.addEventListener('click', event => {
                const currentTarget = event.currentTarget
                
                if(currentTarget === event.target) {
                    closeForm()
                }
            })
            
            document.addEventListener('keydown', event => {
                if(event.key === 'Escape') closeForm() 
            })
            
            wpcf7.addEventListener('wpcf7mailsent', event => {
                const userAgent = navigator.userAgent
                const formData = event.detail && event.detail.inputs ? event.detail.inputs : null
                
                if(!formData) return
                
                const data = {}
                let webhook = null;
                
                formData.forEach(input => {
                    if (input.name === 'webhook') {
                        webhook = input.value
                    } else {
                        data[input.name] = input.value
                    }
                })
                
                if(!webhook) {
                    sent = true
                    document.cookie = `${cookieName}=true;path=/;`
                    
                    closeForm()
                    
                    if(address) {
                        setTimeout(() => {
                            window.open(address, /Mobile|Android|iP(hone|ad)/i.test(userAgent) ? '_top' : '_blank')
                        })
                    }
                } else {
                    fetch(webhook, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(data)
                    })
                    .finally(() => {
                        const fields = wpcf7.querySelectorAll('input:not([type="hidden"]), select, textarea, button[type="submit"]')
                        
                        fields.forEach(field => {
                            field.blur()
                            field.setAttribute('disabled', true)
                        })
                        
                        formTimeout = setTimeout(() => {
                            closeForm()
                        }, 5000)
                    })
                    .then(() => {
                        sent = true
                        document.cookie = `${cookieName}=true;path=/;`
                    })
                    .catch(err => {
                        console.error('Erro ao enviar WebHook:', err.message)
                        
                        closeForm()
                        
                        if(address) {
                            setTimeout(() => {
                                window.open(address, /Mobile|Android|iP(hone|ad)/i.test(userAgent) ? '_top' : '_blank')
                            })
                        }
                    })
                }
            })
        }
    }
    
})(jQuery);